// StationPanelHint – kompaktní tooltip panel pro hover nad feature v mapě: gh_id, název, typ, obs_type (bez foto, souřadnic a výšky)
import { Chip, Separator, Button } from '@heroui/react'

function getDistinctObsTypes(station) {
  if (!station.observation) return []
  return [...new Set(station.observation.map(o => o.obs_type))]
}

function StationHintItem({ station, onSelect, showSelectButton }) {
  const obsTypes = getDistinctObsTypes(station)
  return (
    <div>
      <div className="flex items-center justify-between gap-2 mb-1">
        <span className="font-mono text-gray-400">{station.gh_id}</span>
        <span className="bg-gray-100 px-1.5 py-0.5 rounded text-gray-600">{station.station_type}</span>
      </div>
      <div className="font-semibold text-sm leading-tight text-gray-800">{station.name}</div>
      {station.qual && (
        <div className="text-gray-500 mb-1">{station.qual}</div>
      )}
      {obsTypes.length > 0 && (
        <div className="flex flex-wrap gap-0.5 mb-2">
          {obsTypes.map(t => (
            <Chip key={t} size="sm" variant="flat" className="text-xs h-4 px-1">{t}</Chip>
          ))}
        </div>
      )}
      {showSelectButton && (
        <Button
          size="sm"
          className="w-full mt-1 pointer-events-auto"
          color="primary"
          onClick={() => onSelect?.(station)}
        >
          Vybrat
        </Button>
      )}
    </div>
  )
}

export function StationPanelHint({ station, onStationSelect, onClose, onZoom }) {
  if (!station) return null

  // Cluster selection – seznam stanic s tlačítky Vybrat
  if (station.isClusterSelection && Array.isArray(station.stations)) {
    return (
      <div className="bg-white/95 shadow-lg rounded-xl border border-gray-200 p-2 min-w-[200px] max-w-[280px] text-xs pointer-events-auto max-h-80 overflow-y-auto">
        <div className="flex items-center justify-between gap-2 mb-2">
          <div className="font-semibold text-gray-700">Cluster ({station.stations.length})</div>
          <div className="flex items-center gap-1">
            {onZoom && (
              <button
                onClick={onZoom}
                className="text-gray-400 hover:text-blue-500 text-base leading-none"
                title="Přiblížit na cluster"
              >
                🔍
              </button>
            )}
            {onClose && (
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 text-lg leading-none"
                title="Zavřít"
              >
                ✕
              </button>
            )}
          </div>
        </div>
        {station.stations.map((s, idx) => (
          <div key={s.gh_id}>
            <StationHintItem station={s} onSelect={onStationSelect} showSelectButton={true} />
            {idx < station.stations.length - 1 && <Separator className="my-2" />}
          </div>
        ))}
      </div>
    )
  }

  // Cluster hover hint – seznam stanic bez tlačítek
  if (station.isCluster && Array.isArray(station.stations)) {
    return (
      <div className="bg-white/95 shadow-lg rounded-xl border border-gray-200 p-2 min-w-[160px] max-w-[240px] text-xs pointer-events-none max-h-80 overflow-y-auto">
        <div className="font-semibold text-gray-700 mb-2">Cluster ({station.stations.length})</div>
        {station.stations.map((s, idx) => (
          <div key={s.gh_id}>
            <StationHintItem station={s} />
            {idx < station.stations.length - 1 && <Separator className="my-2" />}
          </div>
        ))}
      </div>
    )
  }

  // Jednotlivá stanice
  return (
    <div className="bg-white/95 shadow-lg rounded-xl border border-gray-200 p-2 min-w-[160px] max-w-[220px] text-xs pointer-events-none">
      <StationHintItem station={station} />
    </div>
  )
}
